import { Component, Input, SimpleChanges } from '@angular/core';
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormGroup
} from '@angular/forms';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { FeedbackService } from '../../../../../../_services/feedback.service';
import { UtilityService } from 'src/app/_services/utility.service';

type Report = {
  competence_discrepancy?: unknown[] | null;
  questions_discrepancy?: unknown[] | null;
  strength_points?: unknown[] | null;
  summary?: Record<string, unknown> | null;
};

@Component({
  selector: 'app-fb360-widget',
  templateUrl: './fb360-widget.component.html',
  styleUrls: ['./fb360-widget.component.css']
})
export class Fb360WidgetComponent {
  @Input() isEdit: boolean = false;
  @Input() chosenUser: string = '';
  @Input() selectedReviewId: number;

  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '290px',
    minHeight: '0',
    maxHeight: 'auto',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    defaultParagraphSeparator: '',
    sanitize: true,
    toolbarHiddenButtons: [
      [
        'insertImage',
        'insertVideo',
        'fontSize',
        'fontName',
        'subscript',
        'superscript',
        'htmlCode',
        'insertHorizontalRule',
        'clearFormatting'
      ]
    ]
  };

  formGoal: FormGroup;
  openedPanelGoalIndex: number | null = null;
  editingGoalIndex: number | null = null;
  editingGrowthIndex: number | null = null;
  openedPanelGrowthIndex: number | null = null;
  isEditSummary: boolean = false;
  openedPanelEditSummary: boolean = false;
  feedbackSummary: any = {};
  isLoading: boolean = true;
  showEmptyDiv: boolean = true;

  feedbackSummaryXample = {
    strength_points: [
      {
        alias: 'Capacità di negozziazione e mediazione',
        counter: 23,
        path: 'assets/images/competenze_trasversali/mediation_skills.png'
      },
      {
        alias: 'Cultura tecnlogica e digitale',
        counter: 16,
        path: 'assets/images/competenze_trasversali/digital_technology.png'
      },
      {
        alias: 'Ascolto attivo ed empatia',
        counter: 12,
        path: 'assets/images/competenze_trasversali/active_listening.png'
      }
    ],
    questions_discrepancy: [
      {
        competence_alias:
          'Capacità di negozziazione e mediazione mediazione mediazione',
        path: 'assets/images/competenze_trasversali/mediation_skills.png',
        text: 'Quanto ti senti sicuro nella tua capacità di negoziare e mediare nella tua capacità di negoziare e mediare?',
        media: 4.62,
        review_evalutaion: 6.24
      },
      {
        competence_alias: 'Capacità di negozziazione e mediazione',
        path: 'assets/images/competenze_trasversali/mediation_skills.png',
        text: 'Quanto ti senti sicuro nella tua capacità di negoziare e mediare nella tua capacità di negoziare e mediare?',
        media: 4.62,
        review_evalutaion: 6.24
      },
      {
        competence_alias: 'Capacità di negozziazione e mediazione',
        path: 'assets/images/competenze_trasversali/mediation_skills.png',
        text: 'Quanto ti senti sicuro nella tua capacità di negoziare e mediare nella tua capacità di negoziare e mediare?',
        media: 4.62,
        review_evalutaion: 6.24
      },
      {
        competence_alias: 'Capacità di negozziazione e mediazione',
        path: 'assets/images/competenze_trasversali/mediation_skills.png',
        text: 'Quanto ti senti sicuro nella tua capacità di negoziare e mediare nella tua capacità di negoziare e mediare?',
        media: 4.62,
        review_evalutaion: 6.24
      }
    ],
    competence_discrepancy: [
      {
        alias: 'Capacità di negozziazione e mediazione',
        path: 'assets/images/competenze_trasversali/mediation_skills.png',
        media_auto: 2,
        media_review: 4.5,
        delta: +4.3
      },
      {
        alias: 'Capacità di negozziazione e mediazione',
        path: 'assets/images/competenze_trasversali/mediation_skills.png',
        media_auto: 2,
        media_review: 4.5,
        delta: +4.3
      },
      {
        alias: 'Capacità di negozziazione e mediazione',
        path: 'assets/images/competenze_trasversali/mediation_skills.png',
        media_auto: 2,
        media_review: 4.5,
        delta: +3.3
      },
      {
        alias: 'Capacità di negozziazione e mediazione',
        path: 'assets/images/competenze_trasversali/mediation_skills.png',
        media_auto: 2,
        media_review: 4.5,
        delta: +2.3
      },
      {
        alias: 'Capacità di negozziazione e mediazione',
        path: 'assets/images/competenze_trasversali/mediation_skills.png',
        media_auto: 2,
        media_review: 4.5,
        delta: +1.3
      },
      {
        alias: 'Capacità di negozziazione e mediazione',
        path: 'assets/images/competenze_trasversali/mediation_skills.png',
        media_auto: 2,
        media_review: 4.5,
        delta: +0.3
      },
      {
        alias: 'Capacità di negozziazione e mediazione',
        path: 'assets/images/competenze_trasversali/mediation_skills.png',
        media_auto: 2,
        media_review: 4.5,
        delta: -1.3
      },
      {
        alias: 'Capacità di negozziazione e mediazione',
        path: 'assets/images/competenze_trasversali/mediation_skills.png',
        media_auto: 2,
        media_review: 4.5,
        delta: -3.3
      }
    ],
    summary:
      'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Sint molestias asperiores similique delectus fugiat eius quos natus veniam itaque libero qui esse laudantium, alias mollitia at error velit, laborum, quia repellat corporis repellendus odit! Veritatis impedit nisi delectus eius enim! Dolores accusamus accusantium eaque quo suscipit, animi repellat praesentium esse incidunt nobis, magni minus at atque. Quod ullam quam nulla est accusamus reprehenderit, ut atque explicabo, sapiente debitis nesciunt dolor tempora facere. Sed numquam fugiat qui corporis odit officiis aperiam, ullam dolorem nulla, vero iste voluptates distinctio expedita eveniet delectus?'
  };

  constructor(
    private readonly fb: FormBuilder,
    public feedbackService: FeedbackService,
    public readonly utilityService: UtilityService
  ) {}

  /**
   * Verifica se il report di feedback 360 è vuoto.
   *
   * - Controlla se gli array `competence_discrepancy`, `questions_discrepancy`
   *   e `strength_points` sono nulli o vuoti.
   * - Controlla se l'oggetto `summary` è nullo o privo di chiavi.
   * @param r
   */
  isReportEmpty(r: Report): boolean {
    const emptyArr = (a?: unknown[] | null) => !a || a.length < 1;
    const emptyObj = (o?: Record<string, unknown> | null) =>
      !o || Object.keys(o).length < 1;

    return (
      emptyArr(r.competence_discrepancy) &&
      emptyArr(r.questions_discrepancy) &&
      emptyArr(r.strength_points) &&
      emptyObj(r.summary)
    );
  }

  ngOnInit() {
    this._initFormGoals();
    if (this.chosenUser && this.selectedReviewId) {
      this.getFeedback360();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      (changes['chosenUser']?.currentValue || this.chosenUser) &&
      changes['selectedReviewId']?.currentValue
    ) {
      this.getFeedback360();
    }
  }

  _initFormGoals() {
    this.formGoal = this.fb.group({
      goal: this.fb.array([]),
      growth: this.fb.array([])
    });
  }

  /**
   * Recupera i dati di feedback 360 per l'utente selezionato e aggiorna il riepilogo interno.
   *
   * - Popola `feedbackSummary` con:
   *   - `questions_discrepancy`: elenco delle discrepanze tra risposte e valutazioni
   *   - `competence_discrepancy`: differenze sulle competenze rilevate
   *   - `strength_points`: punti di forza individuati
   *   - `summary`: commento/testo riassuntivo
   * - Se presente `metadata` in formato JSON valido, richiama `applyGoalsPayload` per gestire obiettivi e crescita.
   * - Imposta `isLoading = false` al termine del caricamento.
   *
   * @returns {void}
   *
   * @example
   * this.getFeedback360();
   *
   * // Dopo la chiamata:
   * console.log(this.feedbackSummary.questions_discrepancy);
   * console.log(this.feedbackSummary.strength_points);
   */
  getFeedback360(): void {
    this.isLoading = true;

    this.feedbackService
      .getFeedback360({
        chosen_user: this.chosenUser,
        selectedReviewId: this.selectedReviewId
      })
      .subscribe(feedback => {
        this.feedbackSummary['questions_discrepancy'] =
          feedback.result?.questions_discrepancy;
        this.feedbackSummary['competence_discrepancy'] =
          feedback.result?.competence_discrepancy;
        this.feedbackSummary['strength_points'] =
          feedback.result?.strength_points;
        this.feedbackSummary['summary'] = feedback.result?.comment;

        const raw = feedback.result?.metadata;
        if (typeof raw === 'string' && raw.trim() !== '') {
          try {
            const meta = JSON.parse(raw);
            if (
              meta &&
              (Array.isArray(meta.goal) || Array.isArray(meta.growth))
            ) {
              this.applyGoalsPayload(meta);
            }
          } catch (e) {
            console.warn('Metadata JSON non valido:', e);
          }
        }
        this.showEmptyDiv = this.isReportEmpty(this.feedbackSummary);
        this.isLoading = false;
      });
  }

  /**
   * Applica al form i dati relativi a obiettivi e crescita provenienti dal payload.
   *
   * - Se `payload.goal` è un array, viene mappato in un FormArray `goal`
   *   contenente form group con `title` e `description`.
   * - Se `payload.growth` è un array, viene mappato in un FormArray `growth`.
   * - Se mancano `title` o `description`, vengono usati valori di fallback
   *   (`"Obiettivo {i+1}"` e stringa vuota).
   * - Al termine il form viene marcato come "pristine".
   *
   * @param {{
   *   goal?: Array<{ title?: string; description?: string }>,
   *   growth?: Array<{ title?: string; description?: string }>
   * }} payload Oggetto contenente gli obiettivi e/o i dati di crescita
   *
   * @returns {void}
   *
   * @example
   * this.applyGoalsPayload({
   *   goal: [
   *     { title: 'Obiettivo 1', description: 'Descrizione obiettivo 1' },
   *     { title: 'Obiettivo 2' } // description opzionale
   *   ],
   *   growth: [
   *     { title: 'Crescita personale', description: 'Approfondire Angular' }
   *   ]
   * });
   */
  applyGoalsPayload(payload: {
    goal?: Array<{ title?: string; description?: string }>;
    growth?: Array<{ title?: string; description?: string }>;
  }): void {
    const goal = Array.isArray(payload?.goal) ? payload.goal : [];
    const growth = Array.isArray(payload?.growth) ? payload.growth : [];

    this.formGoal.setControl(
      'goal',
      this.fb.array(
        goal.map((g, i) =>
          this.createGoal(g.title ?? `Obiettivo ${i + 1}`, g.description ?? '')
        )
      )
    );

    this.formGoal.setControl(
      'growth',
      this.fb.array(
        growth.map((g, i) =>
          this.createGoal(g.title ?? `Obiettivo ${i + 1}`, g.description ?? '')
        )
      )
    );

    this.formGoal.markAsPristine();
  }

  /**
   * Getter per accedere al FormArray degli obiettivi.
   *
   * - Ritorna il FormArray associato alla chiave 'goal' del form principale.
   */
  get goalFA(): FormArray {
    return this.formGoal.get('goal') as FormArray;
  }

  /**
   * Getter per accedere al FormArray della crescita.
   *
   * - Ritorna il FormArray associato alla chiave 'growth' del form principale.
   */
  get growthFA(): FormArray {
    return this.formGoal.get('growth') as FormArray;
  }

  /**
   * Getter per ottenere i controlli del FormArray degli obiettivi.
   *
   * - Ritorna un array di AbstractControl rappresentanti ciascun obiettivo.
   */
  get goals() {
    return this.goalFA.controls;
  }

  /**
   * Getter per ottenere i controlli del FormArray della crescita.
   *
   * - Ritorna un array di AbstractControl rappresentanti ciascun elemento di crescita.
   */
  get growth() {
    return this.growthFA.controls;
  }

  /**
   * Aggiunge un nuovo obiettivo o elemento di crescita al rispettivo FormArray.
   *
   * - Determina il FormArray corretto in base al `type` ('goal' o 'growth').
   * - Calcola l'indice successivo per il titolo (es. "Obiettivo 3").
   */
  addGoal(type: 'goal' | 'growth') {
    const fa = type === 'goal' ? this.goalFA : this.growthFA;
    const nextIndex = fa.length + 1;
    fa.push(this.createGoal(`Obiettivo ${nextIndex}`, ''));
  }

  /**
   * Crea un FormGroup per un obiettivo o elemento di crescita.
   *
   * - Inizializza i campi `title` e `description` con i valori forniti
   * @param title
   * @param description
   */
  createGoal(title = '', description = ''): FormGroup {
    return this.fb.group({
      title: [title],
      description: [description]
    });
  }

  /**
   * Imposta l'indice di editing e pannello aperto per obiettivi o crescita.
   *
   * - Se `type` è 'goal', imposta `editingGoalIndex` e `openedPanelGoalIndex`.
   * - Se `type` è 'growth', imposta `editingGrowthIndex` e `openedPanelGrowthIndex`.
   * @param type
   * @param index
   */
  editGoal(type: 'goal' | 'growth', index: number) {
    if (type === 'goal') {
      this.editingGoalIndex = index;
      this.openedPanelGoalIndex = index;
    } else if (type == 'growth') {
      this.editingGrowthIndex = index;
      this.openedPanelGrowthIndex = index;
    }
  }

  /**
   * Interrompe la propagazione dell'evento.
   *
   * - Previene che l'evento si propaghi agli elementi genitori.
   * @param event
   */
  stopEventPropagation(event: Event) {
    event.stopPropagation();
  }

  /**
   * Gestisce l'apertura/chiusura dei pannelli di obiettivi.
   *
   * - Se `isActive` è true, imposta `openedPanelGoalIndex` a `index`.
   * - Se `isActive` è false, reimposta `openedPanelGoalIndex` a null.
   * @param index
   * @param isActive
   */
  onPanelToggle(index: number, isActive: boolean): void {
    this.openedPanelGoalIndex = isActive ? index : null;
  }

  /**
   * Gestisce l'apertura/chiusura dei pannelli di crescita.
   */
  editSummary() {
    this.openedPanelEditSummary = true;
    this.isEditSummary = true;
  }

  /**
   * Salva i dati correnti del form di descrizione negli obiettivi/crescita
   * richiamando `storeMetadata()` e termina la modalità di editing.
   *
   * - Chiama `storeMetadata()` per persistere i dati aggiornati.
   * - Reimposta a `null` gli indici `editingGoalIndex` e `editingGrowthIndex`
   *   per chiudere la modifica in corso.
   *
   * @returns {void}
   *
   * @example
   * this.saveDescription();
   * // Dopo l'esecuzione non ci sono più campi in editing
   */
  saveDescription(): void {
    this.storeMetadata();

    this.editingGoalIndex = null;
    this.editingGrowthIndex = null;
  }

  /**
   * Rimuove un obiettivo/crescita dal FormArray corrispondente
   * aggiornando indici e titoli, e persiste i dati aggiornati.
   *
   * - Determina il FormArray in base al `type` (`goal` | `growth`).
   * - Rimuove l'elemento all'indice specificato, se esiste.
   * - Aggiorna i titoli degli obiettivi rimasti tramite `updateGoalTitles()`.
   * - Reimposta/aggiusta gli indici di editing e pannelli aperti
   *   (`editingGoalIndex`, `openedPanelGrowthIndex`) per mantenerli coerenti.
   * - Infine richiama `storeMetadata()` per salvare i cambiamenti.
   *
   * @param {'goal' | 'growth'} type Tipo della lista da cui rimuovere l'elemento
   * @param {number} index Indice dell'elemento da eliminare
   *
   * @returns {void}
   *
   * @example
   * // Rimuove il secondo obiettivo
   * this.deleteGoal('goal', 1);
   *
   * // Rimuove il primo elemento della sezione crescita
   * this.deleteGoal('growth', 0);
   */
  deleteGoal(type: 'goal' | 'growth', index: number): void {
    const formArray = this.formGoal.get(type) as FormArray;

    if (formArray && formArray.length > index) {
      formArray.removeAt(index);
      this.updateGoalTitles(type);

      if (this.editingGoalIndex === index) {
        this.editingGoalIndex = null;
      } else if (this.editingGoalIndex! > index) {
        this.editingGoalIndex!--;
      }

      if (this.openedPanelGrowthIndex === index) {
        this.openedPanelGrowthIndex = null;
      } else if (this.openedPanelGrowthIndex! > index) {
        this.openedPanelGrowthIndex!--;
      }
    }

    // Salva i cambiamenti dopo la rimozione! Perché a prescindere non c'è bisogno di creare un delete visto che
    // l'utente può solo salvare i metadata
    this.storeMetadata();
  }

  /**
   * Invia i dati correnti del form di obiettivi/crescita al servizio
   * per la memorizzazione.
   *
   * - Prepara un oggetto `data` con:
   *   - `chosen_user`: l'utente selezionato
   *   - `selectedReviewId`: l'ID della review selezionata
   *   - `metadata`: i dati del form serializzati in JSON
   * - Chiama `reviewF360StoreGoals(data)` del servizio `feedbackService`
   *   per salvare i dati.
   * - Non gestisce la risposta, ma potrebbe essere esteso per feedback all'utente.
   *
   * @returns {void}
   *
   * @example
   * this.storeMetadata();
   * // I dati del form vengono inviati al servizio per la memorizzazione
   */
  private storeMetadata(): void {
    const data = {
      chosen_user: this.chosenUser,
      selectedReviewId: this.selectedReviewId,
      metadata: JSON.stringify(this.formGoal.value)
    };

    this.feedbackService.reviewF360StoreGoals(data).subscribe(response => {});
  }

  /**
   * Aggiorna i titoli degli obiettivi in un FormArray specificato.
   *
   * - Itera sui controlli del FormArray identificato da `arrayName`.
   * - Imposta il campo `title` di ciascun controllo con il formato
   *   "Obiettivo {index + 1}".
   * @param arrayName
   */
  updateGoalTitles(arrayName: string): void {
    const formArray = this.formGoal.get(arrayName) as FormArray;

    formArray.controls.forEach((control, index) => {
      control.get('title')?.setValue(`Obiettivo ${index + 1}`);
    });
  }

  /**
   * Salva il riepilogo di feedback 360 richiamando il servizio
   * e termina la modalità di editing.
   * - Prepara un oggetto `data` con:
   *  - `chosen_user`: l'utente selezionato
   *   - `selectedReviewId`: l'ID della review selezionata
   *   - `comment`: il testo del riepilogo
   *   - Chiama `storeCommentFeedback360(data)` del servizio `feedbackService`
   *   per salvare il riepilogo.
   * - Non gestisce la risposta, ma potrebbe essere esteso per feedback all'utente.
   * - Imposta `isEditSummary = false` per uscire dalla modalità di editing.
   * @returns {void}
   * @example
   * this.saveSummary();
   * // Il riepilogo viene salvato e si esce dalla modalità di editing
   */
  saveSummary(): void {
    const data = {
      chosen_user: this.chosenUser,
      selectedReviewId: this.selectedReviewId,
      comment: this.feedbackSummary.summary
    };

    this.feedbackService
      .storeCommentFeedback360(data)
      .subscribe(response => {});

    this.isEditSummary = false;
  }
}
